module.exports = __webpack_public_path__ + "static/frappe.31b2222b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/frappe.svg
// module id = 739
// module chunks = 263791100135453